import React from 'react';
import { useGoogleLogin } from "@react-oauth/google";
import { AuthType, clearLoginStorage, persistAuthType } from "@shared/utils/AuthUtils";
import { agent } from '@shared/services/agent';
import { setSuccess } from "../../store/registration.duck";
import { setAuthError, setAuthLoading } from "@shared/store/auth.duck";
import { closeDialog } from "@shared/store/dialog.duck";
import { useDispatch } from "react-redux";
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { emitRegisterEvent } from '@features/auth/services/RegisterService';
import { getParameterByName } from "@shared/utils/UrlUtils";
import { TrackJS } from "trackjs";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';
import { trackSignUp } from '@shared/services/MarketingAnalytics';

export function RegisterWithGoogleButton(props: Props) {
  const dispatch = useDispatch();

  const registerWithGoogle = async (tokenResponse: any) => {
    try {
      let requestBody = {};
      const ad = getParameterByName('ad', window.location.href);
      if (ad) {
        // @ts-ignore
        requestBody['ad'] = ad;
      }

      emitRegisterEvent();
      dispatch(setAuthLoading(true));
      persistAuthType(AuthType.Google, dispatch);
      localStorage.setItem('idToken', tokenResponse.access_token);
      localStorage.setItem('accessToken', tokenResponse.access_token);
      const user = await agent.requests.post('/register/google', requestBody, true);
      // Awaited so the hits are sent before the full page navigation below.
      await trackSignUp('google', user?.id, ad);
      dispatch(setSuccess(true));
      window.location.href = '/whereabouts/team';
    } catch (e: any) {
      clearLoginStorage();
      dispatch(setAuthError(e.message));
    } finally {
      dispatch(closeDialog());
      dispatch(setAuthLoading(false));
    }
  }

  const failedGoogleResponse = (error: any) => {
    console.error(error)
    TrackJS?.track(error);
  }

  const googleLogin = useGoogleLogin({
    onSuccess: registerWithGoogle,
    onError: failedGoogleResponse,
    scope: 'https://www.googleapis.com/auth/calendar.events',
  });

  return (
    <>
      <PrimaryButton click={() => googleLogin()} fullWidth={true} size={ButtonSize.Large} text="button.continue-to-signup"/>
    </>
  )
}

interface Props {
}
